// 从版本14升级到15
export const update_sql12 = [
    'ALTER TABLE t_group_member ADD IF NOT EXISTS status;',
    `update t_version set val=15 where key='db_version'`,
];

// 从版本15升级到16
export const update_sql13 = [
    'CREATE TABLE IF NOT EXISTS t_group_send_msg(tid PRIMARY KEY, uid, time);',
    `update t_version set val=16 where key='db_version'`,
];

// 从版本16升级到17
export const update_sql14 = [
    'DROP TABLE IF EXISTS t_user_devices;',
    'CREATE TABLE t_user_devices(uid PRIMARY KEY, devices, lutime, lctime);',
    `update t_version set val=17 where key='db_version'`,
];

// 从版本17升级到18
export const update_sql15 = [
    'ALTER TABLE t_group ADD IF NOT EXISTS join_notice;',
    `update t_version set val=18 where key='db_version'`,
];

// 从版本18升级到19
export const update_sql16 = [
    'ALTER TABLE t_group ADD IF NOT EXISTS group_member_doc VARCHAR(255);',
    'ALTER TABLE t_auth ADD IF NOT EXISTS switch_regist INTEGER DEFAULT 0;',
    'ALTER TABLE t_auth ADD IF NOT EXISTS switch_tab_main INTEGER DEFAULT 0;',
    'ALTER TABLE t_auth ADD IF NOT EXISTS switch_tab_mine INTEGER DEFAULT 1;',
    'ALTER TABLE t_auth ADD IF NOT EXISTS switch_rtc INTEGER DEFAULT 0;',
    `update t_version set val=19 where key='db_version'`,
];

// 从版本19升级到20
export const update_sql17 = [
    'ALTER TABLE t_topic ADD IF NOT EXISTS msg_synced INTEGER DEFAULT 0;',
    `update t_version set val=20 where key='db_version'`,
];

// 从版本20升级到21：给 t_msg 添加 (tid, stime) 复合索引，加速按时间排序的消息查询
export const update_sql18 = [
    'CREATE INDEX IF NOT EXISTS idx_msg_tid_stime ON t_msg(tid, stime DESC);',
    `update t_version set val=21 where key='db_version'`,
];

// 从版本21升级到22：仅抬版本号；t_topic.unread 由 DB.repair_legacy_schema（PRAGMA 幂等 ALTER）补齐，避免列已存在时重复 ALTER 整批失败
export const update_sql19 = [
    `update t_version set val=22 where key='db_version'`,
];

// 从版本22升级到23：仅抬版本号；t_user 缺失列由 repair_legacy_schema 补齐（与 user_upsert 一致）
export const update_sql20 = [
    `update t_version set val=23 where key='db_version'`,
];

// 从版本23升级到24：仅抬版本号；t_topic bridge 列由 repair_legacy_schema（PRAGMA 幂等 ALTER）补齐
export const update_sql21 = [
    `update t_version set val=24 where key='db_version'`,
];
